module.exports = __webpack_public_path__ + "static/hidraulic_transport-c6ea5ae78ed7049b0db289f1cd6595e3.png";